"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledWizardHeader = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../../helpers");
exports.StyledWizardHeader = styled_components_1.default.div `
    padding: 12px ${helpers_1.SPACING_M};

    font-family: ${helpers_1.BASE_FONT_FAMILY};
    font-size: ${helpers_1.FONT_SIZE_M};
    font-weight: ${helpers_1.BASE_FONT_BOLD_WEIGHT};
    line-height: ${helpers_1.FONT_LINE_HEIGHT_M};
    flex-shrink: 0;

    display: flex;
    flex-direction: column;
    align-content: stretch;

    ${({ theme }) => (0, styled_components_1.css) `
        color: ${theme.colorTextMain};
        border-bottom: ${helpers_1.BASE_BORDER_WIDTH} solid ${theme.colorBorderMain};
    `}
`;
//# sourceMappingURL=WizardHeader.styles.js.map